import React, { useState } from "react";
import "./stylesWhiteListRow.css";

import { formatFromUnixTimestamp } from "../../../utils/DateFormatter";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Modal, Table, message } from "antd";

import EditAdminPopup from "../EditAdminPopup/EditAdminPopup";
import UserDeletionModal from "../UserDeletionModal/UserDeletionModal";

function WhiteListRow({
  data,
  setData,
  agentSuperAdmin,
  handlePopupVisible,
  updateAgentToggleStatus,
}) {
  const [isEditAdminModalOpen, setIsEditAdminModalOpen] = useState(false);
  const [isUserDeletionModalOpen, setIsUserDeletionModalOpen] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();

  const handleEditAdminModalOk = () => {
    setIsEditAdminModalOpen(false);
  };

  const handleEditAdminModalCancel = () => {
    setIsEditAdminModalOpen(false);
  };

  const handleUserDeletionModalOk = () => {
    setIsUserDeletionModalOpen(false);
  };

  const handleUserDeletionModalCancel = () => {
    setIsUserDeletionModalOpen(false);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "admin_name",
    },
    {
      title: "Created at",
      dataIndex: "created_at",
      render: (text) => formatFromUnixTimestamp(text),
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Group",
      dataIndex: "group_name",
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-buttons-container">
          <p
            className="add-ip"
            onClick={() =>
              handlePopupVisible(record.admin_id, record.admin_name)
            }
          >
            +
          </p>
          {agentSuperAdmin && (
            <div className="action-buttons-container">
              <p
                className="edit-admin-button"
                onClick={() => {
                  setIsEditAdminModalOpen(true);
                  setSelectedAdmin(record);
                }}
              >
                <EditOutlined />
              </p>
              <p
                className="delete-admin-button"
                onClick={() => {
                  setIsUserDeletionModalOpen(true);
                  setSelectedAdmin(record.admin_id);
                }}
              >
                <DeleteOutlined />
              </p>
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      {contextHolder}

      <Modal
        destroyOnClose
        closable={false}
        open={isEditAdminModalOpen}
        onOk={handleEditAdminModalOk}
        onCancel={handleEditAdminModalCancel}
        footer={null}
        width={400}
      >
        <EditAdminPopup
          handleCancel={handleEditAdminModalCancel}
          selectedAdmin={selectedAdmin}
          setData={setData}
          data={data}
          isEditAdminModalOpen={isEditAdminModalOpen}
        />
      </Modal>
      <Modal
        closable={false}
        open={isUserDeletionModalOpen}
        onOk={handleUserDeletionModalOk}
        onCancel={handleUserDeletionModalCancel}
        footer={null}
        width={400}
      >
        <UserDeletionModal
          handleCancel={handleUserDeletionModalCancel}
          adminId={selectedAdmin}
          setData={setData}
          data={data}
        />
      </Modal>
      <Table
        dataSource={data}
        columns={columns}
        expandable={{
          expandedRowRender: (record) => {
            return (
              <div className="expanded-row">
                <p className="expanded-row-title">Whitelisted IPs</p>
                <div className="expanded-row-labels">
                  {record.whitelisted_ips.map((ip, index) => (
                    <span key={index}>{ip}</span>
                  ))}
                </div>
              </div>
            );
          },
          rowExpandable: (record) => record?.whitelisted_ips?.length > 0,
        }}
        scroll={{ x: 1500, y: 400 }}
      />
    </>
  );
}

export default WhiteListRow;
